import BaseReducer from './base.reducers';
import { TARGET_TENANT_DOMAIN } from '../../../../config';
let options = {};
options.resourceName='CaseMasterList';
options.targetTenantDomain = TARGET_TENANT_DOMAIN;
const SupportCaseMasterListReducer = new BaseReducer(options);
export const SupportCaseMasterListConfig = (state = {}, action) => SupportCaseMasterListReducer.item(state, action);
